module.exports = __webpack_public_path__ + "static/media/sort-caret-default.6078e183.svg";